<section class="company-vision-section" id="company-vision">
  <!-- header section -->
  <div class="company-vision-section__header">
    <!-- title -->
    <pwj-sections-title class="header-title">
      <span class="header-title__label"
        >{{ 'global.company_vision' | translate }}
      </span>
      <span class="header-title__company-name"
        >{{ companyVideoData()?.title | translateData }}
      </span>
    </pwj-sections-title>
  </div>
  <!-- video section -->
  <div class="company-vision-section__content">
    <pwj-video-player
      class="company-vision-section__video"
      playBtnText=""
      [videoPreviewSrc]="companyVideoData()?.video_urls?.url | imageSource"
      btnsClass="!mt-10"
      [isFullWidth]="false"></pwj-video-player>
  </div>
</section>
